import {TimelineItemModel} from "react-chrono/dist/models/TimelineItemModel";


export default class History{

    historyList : any;


    constructor() {
        this.historyList = this.createHistoryList();
    }


    createHistoryList(){
        const arr = [{
            title: '1886',
            cardSubtitle:
                'Gründung durch Ignaz Mehele, Schmiedemeister , eröffnet am 3.  Jänner 1886 eine Schmiedewerkstätte',

            },
            {
                title: '1902',
                cardSubtitle:
                    'Neubau - Werkstätte und Wohnhaus',

            },
            {
                title: '1914',
                cardSubtitle:
                    'Übernahme durch Sohn Josef Mehele geb. 1890',

            },
            {
                title: '1929',
                cardSubtitle:
                    'Geburt von Josef´s Sohn Arnold Mehele',

            },
            {
                title: '1934',
                cardSubtitle:
                    'Kauf der Brauerei – Zur Post – und Umbau zu einer modernen Schmiedewerkstätte Durchführung von Hufbeschlag, ' +
                    'Klauenpflege und Wagenbau',

            },
            {
                title: '1951',
                cardSubtitle:
                    'Meisterprüfung von Arnold Mehele im Schmiedegewerbe u. Hufbeschlag',

            },
            {
                title: '1957',
                cardSubtitle:
                    'Übergabe des Betriebs an Sohn Arnold Mehele. Erste Verkäufe von Traktoren und Landmaschinen',

            },
            {
                title: '1959',
                cardSubtitle:
                    'Meisterprüfung von Arnold Mehele als Landmaschinenmechaniker',

            },
            {
                title: '1964',
                cardSubtitle:
                    'Geburt von Arnold´s Sohn Rainer Mehele \n' +
                    'Übernahme der Landesvertretung von DEUTZ -FAHR Traktoren/Landmaschinen \n' +
                    'Übernahme der RAPID Landesvertretung\n' +
                    'Aufnahme des ersten Lehrlings als Landmaschinenmechaniker',
            },
            {
                title: '1968',
                cardSubtitle:
                    'Geburt von Arnold´s Sohn Stefan Mehele ',
            },
            {
                title: '1970',
                cardSubtitle:
                    'Verschiedene Umbauten zur Betriebserweiterung\n' +
                    'Nachfrage von Landmaschinen aller Art steigt stetig\n',
            },
            {
                title: '1988',
                cardSubtitle:
                    'Erwerb eines 12.000 m2 großen Grundstückes und Errichtung\n' +
                    'einer modernen Ausstellungs- u. Lagerhalle an der Hauptstraße\n',
            },
            {
                title: '1989',
                cardSubtitle:
                    'Rainer Mehele legt die Landmaschinenmechaniker-Meisterprüfung und\n' +
                    'Schlossermeisterprüfung erfolgreich ab\n',
            },
            {
                title: '1990',
                cardSubtitle:
                    'Übernahme der Landesvertretung von ANTONIO CARRARO Mähtraktoren',
            },{
                title: '1991',
                cardSubtitle:
                    'Übergabe des Betriebs an Rainer Mehele',
            },
            {
                title: '1993',
                cardSubtitle:
                    'Übernahme der STEPA Heukran Landesvertretung ',
            },
            {
                title: '1995',
                cardSubtitle:
                    'Stefan Mehele legt die Landmaschinenmechaniker-Meisterprüfung erfolgreich ab',
            },
            {
                title: '1998',
                cardSubtitle:
                    'Übernahme der CLAAS Landmaschinen  Landesvertretung',
            },
            {
                title: '2002',
                cardSubtitle:
                    'Zubau einer überdachten Abstellhalle für Neu und Gebrauchtmaschinen',
            },
            {
                title: '2004',
                cardSubtitle:
                    'Gründung der R u S Mehele Gmbh.  ( Rainer u. Stefan )',
            },
            {
                title: '2011',
                cardSubtitle:
                    'Übernahme der KUHN Landmaschinen  Vertretung',
            },
            {
                title: '2016',
                cardSubtitle:
                    'Jubiläum 130 Jahre Mehele Landtechnik mit 13 Mitarbeitern',
            },
            {
                title: '2020',
                cardSubtitle:
                    'Neubau Betriebsgebäude mit Büro, Ersatzteillager und Werkstätte an der Hauptstraße. ' +
                    'Insgesamt wurden bisher über 50 Lehrlinge als Landmaschinentechniker ausgebildet',
            },



           ] as TimelineItemModel[];

        return arr;


    }
}